import axios from "axios";
axios.defaults.withCredentials = true;

// 環境ごとの接続先
let baseUrl: string;
const origin = global.location.origin;

if (/localhost/.test(origin)) {
  baseUrl = `http://localhost:8080`;
} else if (/tmp/.test(origin)) {
  baseUrl = origin; // 暫定環境
} else {
  baseUrl = origin.replace(/https:\/\/(www\.)*/, "https://api.");
}
axios.defaults.baseURL = baseUrl;

const allowedHeaders = {
  "Content-Type": "application/json",
  "x-app-version": "1.0.0",
};

axios.defaults.headers = allowedHeaders;

// 送信前共通処理
axios.interceptors.request.use((request) => {
  return request;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 後続処理にエラーを知らせる
    return Promise.reject(error.response?.data);
  }
);
